import { useEffect } from "react";
import { useSPAContext } from "@/providers/spa-provider";

// Registers a back action while the component is mounted. Re-registers if the
// provided callback changes. Set `enabled` to false to skip registering.
export function useBackAction(action: () => void, enabled = true) {
  const { registerBackAction } = useSPAContext();

  useEffect(() => {
    if (!enabled) return;
    const unregister = registerBackAction(action);
    return () => unregister();
  }, [action, enabled, registerBackAction]);
}

